import { render } from "./Dialog-layer.vue?vue&type=template&id=1ec55d7f&scoped=true"
import script from "./Dialog-layer.vue?vue&type=script&lang=js"
export * from "./Dialog-layer.vue?vue&type=script&lang=js"

import "./Dialog-layer.vue?vue&type=style&index=0&id=1ec55d7f&scoped=true&lang=css"
import "./Dialog-layer.vue?vue&type=style&index=1&id=1ec55d7f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec55d7f"]])

export default __exports__